import { render, staticRenderFns } from "./MainTemplateTopbar.vue?vue&type=template&id=2fb9d9bc&"
import script from "./MainTemplateTopbar.vue?vue&type=script&lang=js&"
export * from "./MainTemplateTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports